import { useEffect, useState } from "react";
import AddItemForm from "./AddItemFormProps/AddItemForm";
import {
  GetItemToEdit,
  GetItemImageToEdit,
  ResetItemToEdit,
  ResetItemImageToEdit,
} from "../../store/itemAtom";
import AddAssciates from "../AddAssciates";
import { Tabs } from "antd";
import AddItemImageUpload from "./Add-items-props/AddItemImageUpload";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";

function AddItemPage() {
  const itemToEditData = GetItemToEdit();
  const clearItemEdit = ResetItemToEdit();
  const clearItemImageToEdit = ResetItemImageToEdit();
  const getListToEdit = GetItemImageToEdit();
  const [tabActiveKey, setTabActiveKey] = useState("1");
  const navigate = useNavigate();




  useEffect(() => {
    return () => {
      clearItemEdit();
      clearItemImageToEdit();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 
  return (
    <>
      <Tooltip title="Go back to previous page">
        <button
          onClick={() => navigate(-1)}
          className="h-7 w-7 flex items-center justify-center rounded-full hover:bg-gray-200 text-gray-700 focus:outline-none active:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
            />
          </svg>
        </button>
      </Tooltip>

      <div className="md:mt-2 flex">
        <Tabs
          activeKey={tabActiveKey}
          onChange={(key) => setTabActiveKey(key)}
          defaultActiveKey="1"
          items={[
            {
              label: "Item Information",
              key: "1",
              children: (
                <AddItemForm
                  changeTab={setTabActiveKey}
                />
              ),
            },
            {
              label: "Associates Items",
              key: "2",
              children: (
                <AddAssciates item_id={itemToEditData?.item_id}></AddAssciates>
              ),
              disabled:
                !itemToEditData?.item_id ||
                itemToEditData?.item_variety_id !== 2,
            },
            {
              label: "Item Pictures",
              key: "3",
              children: (
                <AddItemImageUpload
                  getListToEdit={getListToEdit}
                  Item_Id={itemToEditData?.item_id}
                />
              ),
              disabled: !itemToEditData?.item_id,
            },
          ]}
        />
      </div>
    </>
  );
}

export default AddItemPage;
